import { SelectOption } from '../components/inputs/Select'
import { SupportedLanguage, SupportedMarket } from '@estercare/ester-shared'

export const getLanguageOptions = (t: (key: string) => string): SelectOption[] => [
  { value: SupportedLanguage.SWEDISH, label: t('common.language.swedish') },
  { value: SupportedLanguage.ENGLISH, label: t('common.language.english') },
  { value: SupportedLanguage.NORWEGIAN, label: t('common.language.norwegian') },
]

/**
 * Determines the default language based on user preferences and market.
 * Priority:
 * 1. User's saved language preference (if exists)
 * 2. Norwegian if user's market is NORWAY
 * 3. Swedish (default fallback)
 *
 * @param userLanguage - The user's saved language preference (if any)
 * @param userMarket - The user's market
 * @returns The default language to use
 */
export const getDefaultLanguage = (
  userLanguage: SupportedLanguage | null | undefined,
  userMarket: SupportedMarket | string | null | undefined
): SupportedLanguage => {
  // First priority: user's explicit language preference
  if (userLanguage) {
    return userLanguage
  }

  // Second priority: market-based default
  if (userMarket === SupportedMarket.NORWAY) {
    return SupportedLanguage.NORWEGIAN
  }

  // Default fallback: Swedish
  return SupportedLanguage.SWEDISH
}
